// frontend/src/services/invoicesAPI.js
import api from '../api/api';

const BASE_URL = '/invoices';

const invoicesAPI = {
  findAll: async () => {
    const response = await api.get(BASE_URL);
    return response.data;
  },

  find: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  create: async (invoiceData) => {
    const response = await api.post(BASE_URL, invoiceData);
    return response.data;
  },

  update: async (id, invoiceData) => {
    const response = await api.put(`${BASE_URL}/${id}`, invoiceData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  // --- FONCTIONS E-FACTURATION (TTN / DIGIGO) ---

  // 1. Générer le XML pour signature
  generateXmlForSigning: async (id) => {
    const response = await api.get(`${BASE_URL}/${id}/generate-xml`);
    return response.data; // Doit retourner { xmlContent: "..." }
  },

  // 2. Upload du XML signé (après signature USB locale)
  uploadSignedXml: async (id, signedXml) => {
    const response = await api.post(`${BASE_URL}/${id}/upload-signed`, { signedXml });
    return response.data;
  },

  // 3. Signature Serveur (Seal) - Utilise les clés du CLIENT stockées en base
  signInvoiceWithSeal: async (id) => {
    const response = await api.post(`${BASE_URL}/${id}/sign-seal`);
    return response.data;
  },

  // 4. Signature par Lot (Seal)
  signBatchWithSeal: async () => {
    const response = await api.post(`${BASE_URL}/batch-sign-seal`);
    return response.data;
  },

  // 5. Envoyer à TTN (Après signature)
  sendToTTN: async (id) => {
    const response = await api.post(`${BASE_URL}/${id}/send-ttn`);
    return response.data;
  },
  
  // 6. Préparation DigiGo (Retourne le hash à signer)
  prepareDigiGoSignature: async (id) => {
    const response = await api.post(`/digigo/prepare-signature`, { invoiceId: id });
    return response.data; // { hash, signingTime }
  },

  // 7. Marquer comme envoyée (workflow)
  markAsSent: async (id) => {
    const response = await api.post(`${BASE_URL}/${id}/mark-sent`);
    return response.data;
  }
};

export default invoicesAPI;